<template>
	<div class="container">
		<div class="main_box" v-loading="isLoading">
			<!--导航-->
			<!-- <navBox></navBox> -->
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div v-if="infoData" class="block_1_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>{{ infoData.product_name || '' }}</div>
					<div
						data-aos="fade-left"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
						style="padding-top: 5px;text-align: right;color: #006BB3;text-decoration: underline;font-style: italic;"
						@click="copyLink"
					>COPY LINK</div>
					<div class="content_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="content_el">
							<div class="left">Catalog #</div>
							<div class="right">{{ infoData.catalog || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Target name</div>
							<div class="right">
								<span v-if="infoData.target_full_name && infoData.synonym">{{ infoData.target_full_name + ', ' + infoData.synonym }}</span>
								<span v-if="infoData.target_full_name && !infoData.synonym">{{ infoData.target_full_name }}</span>
								<span v-if="!infoData.target_full_name && infoData.synonym">{{ infoData.synonym }}</span>
								<span v-if="!infoData.target_full_name && !infoData.synonym"></span>
							</div>
						</div>
						<div class="content_el">
							<div class="left">Immunogen / Antigen details</div>
							<div class="right">{{ infoData.immunogen || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Accession #</div>
							<div class="right">{{ infoData.accession || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Clone ID</div>
							<div class="right">{{ infoData.clone_id || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Isotype</div>
							<div class="right">{{ infoData.Isotype || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Host / Source</div>
							<div class="right">{{ infoData.source_name || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Species / Specificity</div>
							<div class="right">{{ infoData.species || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Tested applications</div>
							<div class="right">
								<div v-if="infoData.apps_name.length > 0">
									<span v-for="(value, index) in infoData.apps_name" :key="index">
										{{ index == infoData.apps_name.length - 1 ? value.title : value.title + ', ' }}
									</span>
								</div>
							</div>
						</div>
						<div class="content_el">
							<div class="left">Unit</div>
							<div class="right">{{ infoData.unit || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Packaging</div>
							<div class="right">{{ infoData.package || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Format</div>
							<div class="right">
								<div v-if="infoData.format_name.length > 0">
									<span v-for="(value, index) in infoData.format_name" :key="index">
										{{ index == infoData.format_name.length - 1 ? value.title : value.title + ', ' }}
									</span>
								</div>
							</div>
						</div>
						<div class="content_el">
							<div class="left">Purity</div>
							<div class="right">{{ infoData.purity || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Buffer</div>
							<div class="right">{{ infoData.buffer || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Preservative</div>
							<div class="right">{{ infoData.preservative || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left">Storage</div>
							<div class="right">{{ infoData.storage || '' }}</div>
						</div>
						<div class="content_el">
							<div class="left" style="border-bottom: 1px solid #707070;">Shelf life</div>
							<div class="right" style="border-bottom: 1px solid #707070;">{{ infoData.shelf_life || '' }}</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div v-if="infoData && infoData.img_list.length > 0" class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="300"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_2_main">
					<van-swipe
						class=""
						:autoplay="3000"
						indicator-color="#006BB3"
						ref="swipeOne"
						:stop-propagation="false"
						:touchable="false"
					>
						<van-swipe-item v-for="(value, index) in infoData.img_list" :key="index">
							<div class="banner_el">
								<img :src="weburl + value.thumb" />
								<div class="title">{{ value.miaoshu }}</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<!-- <footerBox></footerBox> -->
			<!--版权-->
		</div>
		<!--loading-->
		<!-- <transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition> -->
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { getProductDetail } from '@/api/public.js';
import { UPURL } from '@/util/util.js';
export default {
	props: ['msg'],
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			weburl: '',
			infoMsg: this.msg
		}
	},
	created(){
		let that = this;
		that.weburl = UPURL;
		if(that.infoMsg) {
			getProductDetail({ custom: that.infoMsg }).then(res => {
				that.infoData = res.data;
				document.title = that.infoData.product_name + ' - Jtests | IVD Active Materials';
				that.isLoading = false;
			});
		}else {
			that.isLoading = false;
			that.$toast('Product parameter exception, failed to obtain details.');
		}
	},
	mounted() {
		let that = this;
	},
	methods: {
		//复制链接
		copyLink() {
			let that = this;
			that.$copyText('https://ucreagent.com/products/' + that.infoMsg).then(() => {
				that.$toast('Link copied');
			}).catch(() => {
				that.$toast('Copy failed');
			});
		},
		goProducts() {
			this.$router.push('/products');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块2
	.block_2{
		padding: 0px 20px;
		.block_2_main{
			width: 100%;
			.banner_el{
				.title{
					padding: 30px 0;
					font-size: 18px;
					text-align: center;
				}
				img{
					width: 100%;
				}
			}
		}
	}
	//块1
	.block_1{
		padding: 30px 20px 50px 20px;
		.block_1_main{
			width: 100%;
			margin: 0 auto;
			.content_box{
				padding: 20px 0 0 0;
				.content_el{
					display: flex;
					.right{
						flex: 1.5;
						padding: 10px 15px;
						font-size: 16px;
						border-top: 1px solid #707070;
						border-right: 1px solid #707070;
						border-bottom: 0px solid #707070;
						border-left: 1px solid #707070;
					}
					.left{
						flex: 1;
						padding: 10px 15px;
						font-weight: bold;
						font-size: 16px;
						border-top: 1px solid #707070;
						border-bottom: 0px solid #707070;
						border-left: 1px solid #707070;
					}
				}
			}
			.title{
				font-size: 36px;
				font-weight: bold;
				color: #006BB3;
				text-align: center;
			}
		}
	}
	//位置块
	.location_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 30px;
		.icon{
			top: 4px;
		}
		span{
			display: inline-block;
			padding: 0 5px;
			font-size: 16px;
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box th{
	padding: 12px;
	background-color: #9F58AE;
	color: #ffffff;
}
>>> .main_box td, >>> .main_box th {
	border: 1px solid #CCCCCC;
	font-size: 16px;
}
>>> .main_box table {
	max-width: 100%;
	border-collapse: collapse;
}
</style>